// extracted by mini-css-extract-plugin
module.exports = {"fastChart":"FastChart_fastChart__aaXWE"};